(function () {
    "use strict";

    angular.module("app").component("whatsNewOverview", {
        template: `<div class="whats-new-overview">
            <div class="row" ng-if="!vm.items || !vm.items.length" style="display: flex; justify-content: center; align-items: center;">
                <span i18n="WhatsNew_NoItems" style="padding: 30px 0;"></span>
            </div>
            <table class="table table-striped table-hover" ng-if="vm.items && vm.items.length">
                <thead>
                    <tr>
                        <th i18n="WhatsNew_Date"></th>
                        <th i18n="WhatsNew_Title"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="whats-new-item" ng-repeat="item in vm.items" ng-click="vm.viewItem(item)">
                        <td>{{item.CreatedTimestamp | date:'dd/MM/yyyy'}}</td>
                        <td>{{item.Title}}</td>{{clicked}}
                    </tr>
                </tbody>
            </table>
            <style>
            .whats-new-item {
                cursor: pointer;
            }
            .whats-new-item:active {
                filter: brightness(0.95);
            }
            </style>
        </div>`,
        controller: OverviewController,
        controllerAs: "vm",
    });

    OverviewController.$inject = [
        "$rootScope", "controllerDecorator",
        "whatsNewApi", "whatsNewSharedUtils",
    ];
    function OverviewController(
        $rootScope, controllerDecorator,
        whatsNewApi, utils,
    ) {
        const vm = this;

        controllerDecorator.Decorate(vm, ["dialog"]);

        vm.items = null;
        vm.viewItem = viewItem;
        vm.since = vm.ParsePrettyUrl().parameters["published_since"];

        init();

        function init() {
            const getHistory = vm.since ? whatsNewApi.GetHistorySince(vm.since) : whatsNewApi.GetHistory;

            getHistory(
                ({ status, data }) => {
                    if (status !== 200) {
                        return;
                    }

                    vm.items = data;
                },
                error => {
                    console.error("Error while loading the what's new items.", error);
                },
                () => {
                    vm.SetLoadingState(false);
                });
        };

        function viewItem(item) {
            const { html, images } = utils.extractCoverImages(item.Body);

            const $creationScope = Object.assign($rootScope.$new(true), {
                slideDuration: 5,
                item: { ...item, Body: html, images },
                closeModal: () => {
                    vm.Dialog.CloseAll();
                },
            });

            vm.Dialog.Custom({
                templateHtml: whatsNewTemplate,
                scope: $creationScope,
                size: "large",
                onEscape: true,
                closeButton: true,
                title: vm.getTranslation("WhatsNew_Title"),
                buttons: {},
                onHidden: () => {
                    // Cleanup the scope when the modal closes.
                    $creationScope.$destroy();
                }
            });
        }

        const whatsNewTemplate = `
                <div class="whats-new__content">
                    <div class="whats-new__image-container">
                        <figure class="whats-new__image-slide"
                            ng-repeat="imageSrc in item.images track by $index"
                            ng-style="item.images.length > 1 ? {
                                'animation-delay': ($index * slideDuration) + 's',
                                'animation-duration': (item.images.length * slideDuration) + 's',
                            } : {}"
                            ng-class="{ 'whats-new__no-anim': item.images.length === 1 }">

                            <div class="whats-new__bg-image--blur" ng-style="{ 'background-image': 'url(' + imageSrc + ')' }"></div>

                            <img ng-src="{{imageSrc}}" alt="item.Title" ng-class="{ 'whats-new__no-img': item.images === 0 }">
                            <figcaption>{{item.Title}}</figcaption>
                        </figure>
                    </div>
                    <div class="whats-new__text_container" ng-bind-html="item.Body"></div>
                </div>
                <div class="wizard-actions text-right no-shrink">
                    <button type="button"
                        class="btn btn-default"
                        i18n="CloseScreen"
                        ng-click="closeModal()"
                    </button>
            </div>`;
    }
})();